import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  CalendarCheck,
  HelpCircle,
  HeartHandshake,
  ShieldCheck,
  Sparkles,
} from "lucide-react";
import SpaceCard from "./SpaceCard";
import {
  defaultPhoenixSpaces,
  phoenixHubContent,
  supportedActivities,
} from "./config";
import { loadPhoenixSpaces } from "./service";
import "./PhoenixHub.css";

export default function PhoenixHubLanding() {
  const [spaces, setSpaces] = useState(defaultPhoenixSpaces);
  useEffect(() => {
    loadPhoenixSpaces().then(setSpaces);
  }, []);

  return (
    <div className="phx-shell">
      <section className="phx-hero">
        <div className="phx-hero-copy">
          <p className="phx-kicker">{phoenixHubContent.eyebrow}</p>
          <h1>{phoenixHubContent.publicName}</h1>
          <p className="phx-lead">{phoenixHubContent.introduction}</p>
          <div className="phx-actions">
            <Link className="phx-button" to="/phoenix-hub/book">
              Request a Booking <ArrowRight aria-hidden="true" />
            </Link>
            <Link className="phx-button phx-button-secondary" to="/phoenix-hub/spaces">
              View Our Spaces
            </Link>
          </div>
        </div>
        <div className="phx-hero-panel" aria-label="Booking process">
          <Sparkles aria-hidden="true" />
          <p className="phx-kicker">A considered booking process</p>
          <ol>
            <li><span>1</span> Request</li>
            <li><span>2</span> Review</li>
            <li><span>3</span> Approval</li>
            <li><span>4</span> Payment</li>
            <li><span>5</span> Confirmation</li>
          </ol>
          <p>No booking is confirmed until UUN sends written confirmation.</p>
        </div>
      </section>

      <section className="phx-section phx-intro-grid">
        <div>
          <p className="phx-kicker">A place for local life</p>
          <h2>Flexible space for ideas, activity and connection</h2>
          <p>
            From weekly wellbeing classes to one-off celebrations and community advice,
            Phoenix Hub can be arranged around the people and programmes it serves.
          </p>
        </div>
        <ul className="phx-activity-grid">
          {supportedActivities.map((activity) => <li key={activity}><ShieldCheck aria-hidden="true" /> {activity}</li>)}
        </ul>
      </section>

      <aside className="phx-notice" role="note">
        <CalendarCheck aria-hidden="true" />
        <div>
          <h2>Important booking notice</h2>
          <p>{phoenixHubContent.bookingNotice}</p>
        </div>
      </aside>

      <section className="phx-section">
        <div className="phx-section-heading">
          <div><p className="phx-kicker">Explore Phoenix Hub</p><h2>Choose the right space</h2></div>
          <Link to="/phoenix-hub/spaces">View full space details <ArrowRight aria-hidden="true" /></Link>
        </div>
        <div className="phx-card-grid">
          {spaces.map((space) => <SpaceCard key={space.id} space={space} />)}
        </div>
        <p className="phx-pricing-note">{phoenixHubContent.pricingNote}</p>
      </section>

      <section className="phx-cta-grid">
        <Link to="/phoenix-hub/book"><CalendarCheck aria-hidden="true" /><span><strong>Request a booking</strong>Tell us what you need and when.</span></Link>
        <Link to={phoenixHubContent.enquiryEmail ? `mailto:${phoenixHubContent.enquiryEmail}?subject=Phoenix Hub booking question` : "/get-involved"}><HelpCircle aria-hidden="true" /><span><strong>Ask a booking question</strong>Speak to the UUN team before applying.</span></Link>
        <Link to="/phoenix-hub/spaces"><Sparkles aria-hidden="true" /><span><strong>View spaces</strong>Compare room uses, facilities and rates.</span></Link>
        <Link to="/get-involved"><HeartHandshake aria-hidden="true" /><span><strong>Become a programme partner</strong>Explore regular and collaborative delivery.</span></Link>
      </section>
    </div>
  );
}
